import { useIsMobileDevice } from './useIsMobileDevice';

export function useDeviceCondition<D, M>(desktop: D, mobile: M): D | M {
  const isMobile = useIsMobileDevice();

  return isMobile ? mobile : desktop;
}
